<div class="bsg-content-wrapper">
  <main id="content" role="main">
    <h3>
      <p>{{title}}</p>
    </h3>
    <br>
    <h4>
      <p></p>
    </h4>
    <br>
    <button class="btn btn-primary" type="button"
            (click)="logoutAndRedirect()">{{'notAutorizedLoginRedirect' | translate}}</button>
  </main>
</div>
